// This will be replaced at build time with the actual environment value
const REACT_APP_ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;

// Common configuration shared between environments
const commonConfig = {
  organizationName: 'RicoCorp',
  applicationName: 'Virtus',
  introVideo: {
    url: 'https://rcragtd4tl.blob.core.windows.net/rc-virtus/Materiales/Virtus%20Auto%20-%20Formacio%CC%81n%20Inicial.mp4?sp=r&st=2025-05-27T16:54:48Z&se=2030-06-01T00:54:48Z&spr=https&sv=2024-11-04&sr=b&sig=TXUjki1mqHDIziSSUkuBK4Wpz82chEsPWNDwFWZKsjQ%3D',
  },
  organizations: {
    Madel: {
      Logo: './Images/madel_logo.png',
      Title1: 'Madel',
      Title2: 'Autoescuelas',
      BoxText: 'ricocorp',
      Description:
        'Conduciendo el futuro: Aprendizaje inteligente para conductores y educadores.',
      CreditsRemain: 'creditos restantes',
      Tools: 'Utilidades',
      MyProfile: 'Mi Perfil',
    },
    RicoCorp: {
      Logo: './Images/ricocorp_logo.png',
      Title1: 'Virtus',
      Title2: 'Platform',
      BoxText: 'ricocorp',
      Description:
        'Building the Future: Custom AI Solutions for Healthcare, IT, and Businesses.',
      CreditsRemain: 'credits remain',
      Tools: 'Tools',
      MyProfile: 'My Profile',
    },
    VedMed: {
      Logo: './Images/ricocorp_logo.png',
      Title1: 'VedMed',
      Title2: '',
      BoxText: 'ricocorp',
      Description: 'Building the Future: Custom AI Solutions for Healthcare.',
      CreditsRemain: 'credits remain',
      Tools: 'Tools',
      MyProfile: 'My Profile',
    },
  },
};

// Environment-specific configurations
const envConfigs = {
  development: {
    baseURL: 'https://llm-api-dev.vrtus.app',
    landingPageUrl: 'http://localhost:3080',
    stripe: {
      free: 'price_1JcQD6HIZYvvnKladKayEvOZ',
      entry: 'price_1JL68HHIZYvvnKlaBJWS5uDe',
      pro: 'price_1JLQhlHIZYvvnKlakrqF8khB',
      virtus_topup: 'price_1PWzFa2MsGE027IGnNYlcse7',
    },
    llmApiBaseUrl: 'https://llm-api-dev.vrtus.app',
    hermesApiBaseUrl: 'https://hermes-api-dev.vrtus.app',
  },
  production: {
    baseURL: 'https://llm-api-prod.vrtus.app',
    landingPageUrl: 'https://llm-api-prod.vrtus.app',
    stripe: {
      free: 'price_1JcQsUHIZYvvnKlaEPy958NF',
      entry: 'price_1JLpWpHIZYvvnKlaHxiCr7Js',
      pro: 'price_1JLpWxHIZYvvnKlamATZ7Awm',
      virtus_topup: 'price_1PWzFa2MsGE027IGnNYlcse7',
    },
    llmApiBaseUrl: 'https://llm-api-prod.vrtus.app',
    hermesApiBaseUrl: 'https://hermes-api-prod.vrtus.app',
  },
};

// Determine which environment to use - this will be evaluated at build time
// If REACT_APP_ENV is 'development', use development config, otherwise use production
const envConfig = envConfigs[REACT_APP_ENV] || envConfigs.production;

// Combine common config with environment-specific config
const config = { ...commonConfig, ...envConfig };

// Log which environment we're using at startup (debug)
console.log(
  `Using ${REACT_APP_ENV} environment: API URLs: LLM=${config.llmApiBaseUrl}, Hermes=${config.hermesApiBaseUrl}`
);

export default config;
